import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../../../core/utils/is-slot.js';
import { charsFontWidth12pixelsSize400Map } from '../../text-ellipsis/chars-font-width-map.js';
import { calculateWidth } from '../../text-ellipsis/truncate-string.js';
import { MARKER_LABEL_PADDING } from '../constants.js';
import { TrackAtom } from '../slots/TrackAtom.js';

export type LabelInfo = {
  id: string;
  text: string;
  isTruncated: boolean;
};

export function computeLabelsPerTrack(
  children: ReactNode,
  labelsWidth: number,
): LabelInfo[] {
  const result: LabelInfo[] = [];
  const maxWidth = labelsWidth - MARKER_LABEL_PADDING;

  let trackIndex = 0;
  Children.forEach(children, (track) => {
    if (isSlot(track, TrackAtom) && !track.props.hidden) {
      const label = track.props.label;
      if (label) {
        const textWidth = calculateWidth(
          label,
          charsFontWidth12pixelsSize400Map,
        );
        result.push({
          id: `track-${trackIndex}`,
          text: label,
          isTruncated: textWidth > maxWidth,
        });
      } else {
        result.push({
          id: `track-${trackIndex}`,
          text: '',
          isTruncated: false,
        });
      }
      trackIndex++;
    }
  });

  return result;
}
